<template>
    <div>
        <thin-line-pie-chart
            :animate="false"
            :percentage="row.gross_potential_percentage / 100"
            v-if="row.gross_potential_percentage > 0"
        />
        <div class="text-center" v-else>&mdash;</div>
    </div>
</template>

<script>
export default {
    props: ['row'],
};
</script>
